import React from 'react';
import LegalDocumentPage from '../components/LegalDocumentPage';

const TermsOfService = () => <LegalDocumentPage slug="terms" testid="terms-page" />;

export default TermsOfService;
